import axios from 'axios'

const api = axios.create({
  baseURL: '/api/v1', // change to your Django backend URL
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // important for CSRF cookies
})

// Configure CSRF token names for Django
api.defaults.withCredentials = true
api.defaults.xsrfCookieName = 'csrftoken'
api.defaults.xsrfHeaderName = 'X-CSRFToken'

export default api